import { useAppState } from "@/modules/app/useAppContext";
import { AllQueries as AllQueriesLegacy } from "../Query";
import AllQueries from "./AllQueries";
import { useBreadcrumb } from "@/components/breadcrumbs";

interface AllQueriesWrapperProps {
  queryHash?: string;
}

const AllQueriesWrapper = ({ queryHash }: AllQueriesWrapperProps) => {
  useBreadcrumb("All Queries", {
    defaultParents: [{ label: "Code", pathname: "/query" }],
    truncateTo: "/query",
  });

  const { enableCustomWorkloadsChartAggregation } = useAppState();

  if (enableCustomWorkloadsChartAggregation) {
    return <AllQueries queryHash={queryHash} />;
  }

  // Legacy component doesn't accept queryHash prop
  return <AllQueriesLegacy />;
};

export default AllQueriesWrapper;
